import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  search_candidate_action,
  invite_candidate_to_assessment_kit_action,
} from "../../../../redux/_actions";
import { } from "react-router-dom";
import { showSuccessMessage } from "../../../../_uiComponents/ShowMessageSnack";
function useSuggestedCandidates({ interviewKitSkills, interviewKit }) {
  const [suggestedCandidates, setSuggestedCandidates] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [assessmentAssignId, setAssessmentAssignId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchInputRef2 = useRef();

  const { searchCandidateData } = useSelector(
    (state) => state.search_candidate_reducer
  );

  useEffect(() => {
    getSuggestedCandidatesApi();
  }, []);

  useEffect(() => {
    if (interviewKitSkills) getSuggestedCandidatesApi();
  }, [interviewKitSkills]);

  useEffect(() => {
    if (searchCandidateData?.data) {
      setSuggestedCandidates(searchCandidateData?.data);
    }
  }, [searchCandidateData]);

  const getSuggestedCandidatesApi = async (value) => {
    const data = {
      index: "candidate_profile",
      search_key: "",
      search: value ? value : "",
      skill_names: value ? [] : "",
    };
    await dispatch(search_candidate_action(data));
  };

  const onViewCandidateProfileClick = (id) => {
    if (id) navigate(`/view-candidate-profile/${id}`, { state: id });
  };

  const onSearch = () => {
    if (showSearch) {
      searchInputRef2.current.value = "";
    }
    setShowSearch((showSearch) => !showSearch);
    getSuggestedCandidatesApi();
  };

  const onSearchInputChange = async (e) => {
    let value = e.target.value;

    setShowSearch(true);
    getSuggestedCandidatesApi(value);
  };

  const onAssignAssessmentClick = async (id) => {
    setAssessmentAssignId(id);
    await dispatch(
      invite_candidate_to_assessment_kit_action({
        interview_kit: interviewKit?.id,
        candidate: id,
      })
    );
    setAssessmentAssignId(null);
  };

  const onShareAssessmentClick = (id) => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const url = isDev
      ? `http://localhost:3000/view-candidate-profile/${id}
`
      : `${process.env.REACT_APP_DEV_ROOT_URL}/view-candidate-profile/${id}
`;
    window.navigator.clipboard.writeText(url);
    showSuccessMessage(`Share Assessment Url Copied ${url}`);
  }; 
  return {
    suggestedCandidates,
    showSearch,
    searchInputRef2,
    onSearch,
    onSearchInputChange,
    onViewCandidateProfileClick,
    onAssignAssessmentClick,
    onShareAssessmentClick,
  };
}

export default useSuggestedCandidates;
